<template>
  <div class="app-upload-button">
    <!-- <el-button size="mini" type="primary" @click="choseFile">
      <i class="bx bx-folder-open font-size-14 align-middle me-2"></i>
      {{ text }}
    </el-button> -->
    <button
      @click="choseFile"
      :disabled="disabled || showProgress"
      type="button"
      class="btn btn-sm btn-primary"
    >
      <i
        class="bx bx-folder-open font-size-14 me-2 align-middle"
        v-if="!showProgress"
      ></i
      ><i v-else class="bx el-icon-loading font-size-14 me-2 align-middle"></i
      ><span>{{ text }}</span>
    </button>
    <!-- <show-progress
      v-if="showProgress"
      :dataName="upload_name"
      :remove="removeProgress"
    ></show-progress> -->
    <image-edit ref="imageEdit" @change="toFather"></image-edit>
    <el-dialog
      title="添加方式选择"
      width="260px"
      :visible.sync="uploadMethod"
      append-to-body
    >
      <div style="display: flex">
        <el-button type="primary" :disabled="!power['查看']" @click="openVod"
          >媒资库导入</el-button
        >
        <el-button type="primary" style="margin-left: 10px" @click="choseFiles"
          >本地上传</el-button
        >
      </div>
      <slot name="uploadWarning"></slot>
    </el-dialog>
    <el-dialog
      title="转存媒资库"
      width="500px"
      :visible.sync="vodDialog"
      append-to-body
    >
      <div class="flex-center">
        文件标题<el-input
          v-model="title"
          style="width: 300px; margin-left: 10px"
          placeholder="文件标题"
        ></el-input>
      </div>
      <span slot="footer">
        <el-button style="margin-left: 10px" @click="vodDialog = false"
          >取消</el-button
        >
        <el-button type="primary" style="margin-left: 10px" @click="save_to_vod"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <chose-from-vod
      @change="toFather"
      :fileDetail="true"
      ref="mediaVod"
    ></chose-from-vod>
  </div>
</template>

<script>
import { uploadFile } from "@/server/api/cos";
// import showProgress from "@/components/uploadProgress/showProgress.vue";
import ImageEdit from "@/components/ImageEdit.vue";
import uuid from "uuid-js";
import { saveToVod } from "@/server/api/mediaLibrary.js";
import ChoseFromVod from "@/components/choseFromVod/ChoseFromVod.vue";
import { getVideoDuration } from "@/util/fun.js";
import { EventBus } from "@/util/eventBus.js";
export default {
  components: {
    // showProgress,
    ImageEdit,
    ChoseFromVod,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isFile: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "点击上传",
    },
    type: {
      type: String,
      default: "image",
    },
    size: {
      type: String,
      default: "1:1",
    },
    index: {
      type: Number,
      default: 9999,
    },
    edit: {
      type: Boolean,
      default: true,
    },
    fileType: {
      //设置文件类型
      type: String,
      default: "",
    },
    format: {
      //文件返回类型
      type: String,
      default: "",
    },
    pathDir: {
      type: String,
      default: "/saas",
    },
  },
  data() {
    return {
      progressPercent: 0,
      showProgress: false,
      sliderStyle: {},
      upload_name: "",
      fileInfo: {},
      power: {},
      uploadMethod: false,
      vodDialog: false,
      title: "",
      url: "",
      file_type: "", //上传的文件类型
      videoDuration: 0,
      removeProgress: true,
    };
  },

  mounted() {
    this.power = this.utils.currentPower("媒体资源库管理");
  },

  methods: {
    //打开媒资库选择弹窗
    openVod() {
      this.uploadMethod = false;
      //this.$refs.mediaVod.openModal(this.type);
      let type = this.type;
      if (type == "image") {
        this.$refs.mediaVod.openModal("image");
      } else if (type == "audio") {
        this.$refs.mediaVod.openModal("audio");
      } else if (type == "video") {
        this.$refs.mediaVod.openModal("video");
      } else if (type == "imageOrVideo") {
        this.$refs.mediaVod.openModal("image", true, {
          allTypes: false,
          imageOrVideo: true,
          videoOrAudio: false,
          imageOrAudio: false,
        });
      } else if (type == "imageOrVideoOrAudio") {
        this.$refs.mediaVod.openModal("image", true, {
          allTypes: true,
          imageOrVideo: false,
          videoOrAudio: false,
          imageOrAudio: false,
        });
      } else {
        return;
      }
    },
    choseFile() {
      // this.choseFiles();
      if (
        this.power["查看"] &&
        ["excel", "directory", "glb"].indexOf(this.type) === -1
      ) {
        this.uploadMethod = true;
      } else {
        this.choseFiles();
      }
    },
    //COS前端上传
    choseFiles() {
      this.uploadMethod = false;
      let inputElem = document.createElement("input"); //创建文件选择
      let filetype = "";
      let type = this.type;
      if (type == "image") {
        filetype = ".jpg, .jpeg, .png, .gif, .webp";
      } else if (type == "audio") {
        filetype =
          ".aac, .adpcm, .amr, .dsd, .mp1, .mp2, .mp3, .pcm, .realaudio, .wma,";
      } else if (type == "video") {
        filetype = ".mp4,";
      } else if (type == "excel") {
        filetype = ".xls, .xlsx,";
      } else if (type == "directory") {
        inputElem.setAttribute("directory", "");
        inputElem.setAttribute("webkitdirectory", "");
      } else if (type == "imageOrVideo") {
        filetype = ".jpg, .jpeg, .png, .gif, .webp, .mp4";
      } else if (type == "imageOrVideoOrAudio") {
        filetype =
          ".jpg, .jpeg, .png, .gif, .webp, .mp4, .aac, .adpcm, .amr, .dsd, .mp1, .mp2, .mp3, .pcm, .realaudio, .wma";
      } else if (type == "glb") {
        filetype = ".glb";
      }
      if (this.fileType) {
        filetype = this.fileType;
      }
      // filetype = ".pdf, .txt, .jpeg, .png, .gif, .ico, .svg";
      inputElem.setAttribute("type", "file");
      if (filetype) {
        inputElem.setAttribute("accept", filetype);
      }
      inputElem.onchange = this.upload;
      inputElem.click();
    },
    upload(e) {
      // let test = {};
      // for (let a in e) {
      //   test[a] = e[a];
      // }
      // console.log("要上传的文件", test);
      let file = e.target.files[0];
      this.title = file.name.substring(0, file.name.lastIndexOf("."));
      this.fileInfo = {
        name: file.name,
        size: file.size,
        type: this.type,
      };
      this.upload_name = uuid.create().hex;
      let file_format = file.name
        .split(".")
        .splice(-1, 1)[0]
        .toLowerCase();
      if (this.fileType) {
        if (this.fileType.indexOf(file_format) == -1) {
          this.warning("不支持上传此格式文件");
          return;
        }
      }
      if (this.type == "imageOrVideo") {
        if (file.type.indexOf("image") != -1) {
          this.file_type = "image";
          if (!this.fileType) {
            if ("jpeg,png,jpg,webp,gif".indexOf(file_format) == -1) {
              this.warning("不支持上传此格式文件");
              return;
            }
          }
        } else if (file.type.indexOf("video") != -1) {
          this.file_type = "video";
          if (!this.fileType) {
            if ("mp4".indexOf(file_format) == -1) {
              this.warning("不支持上传此格式文件");
              return;
            }
          }
        } else {
          this.warning("不支持上传此格式文件");
          return;
        }
      }
      if (this.type == "imageOrVideoOrAudio") {
        if (file.type.indexOf("image") != -1) {
          this.file_type = "image";
          if (!this.fileType) {
            if ("jpeg,png,jpg,webp,gif".indexOf(file_format) == -1) {
              this.warning("不支持上传此格式文件");
              return;
            }
          }
        } else if (file.type.indexOf("video") != -1) {
          this.file_type = "video";
          if (!this.fileType) {
            if ("mp4".indexOf(file_format) == -1) {
              this.warning("不支持上传此格式文件");
              return;
            }
          }
        } else if (file.type.indexOf("audio") != -1) {
          this.file_type = "audio";
          if (!this.fileType) {
            if (
              "aac,adpcm,amr,dsd,mp1,mp2,mp3,pcm,realaudio,wma".indexOf(
                file_format
              ) == -1
            ) {
              this.warning("不支持上传此格式文件");
              return;
            }
          }
        } else {
          this.warning("不支持上传此格式文件");
          return;
        }
      }
      if (this.type === "image") {
        if (this.fileType) {
          if (this.fileType.indexOf(file_format) == -1) {
            this.warning("不支持上传此格式文件");
            return;
          }
        } else {
          const isImage =
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "image/webp" ||
            file.type === "image/gif";
          if (!isImage) {
            this.info("只支持上传图片格式");
            return;
          }
          this.imageCheck(file);
          return;
        }
      }
      this.removeProgress = true;
      if (this.type === "video") {
        this.removeProgress = false;
        if (this.fileType) {
          if (this.fileType.indexOf(file_format) == -1) {
            this.warning("不支持上传此格式文件");
            return;
          }
        } else if (file.type != "video/mp4") {
          this.info("只支持上传mp4视频文件");
          return;
        }
        getVideoDuration(file, (data) => {
          this.videoDuration = data;
        });
        let size = file.size;
        let unit = "";
        size = (size / 1024).toFixed(1);
        if (size < 1024) {
          unit = "KB";
        } else {
          size = (size / 1024).toFixed(1);
          if (size < 1024) {
            unit = "MB";
          } else {
            size = (size / 1024).toFixed(1);
            if (size < 1024) {
              unit = "GB";
            }
          }
        }
        EventBus.$emit("mediaLibrary", {
          name: file.name,
          sessionName: this.upload_name,
          rate: 0,
          loaded: 0,
          size: size,
          unit: unit,
          status: "active",
          type: "video",
          path: "",
        });
      }
      if (this.type === "excel") {
        if (this.fileType) {
          if (this.fileType.indexOf(file_format) == -1) {
            this.warning("不支持上传此格式文件");
            return;
          }
        } else {
          let reg = /^.*\.(?:xls|xlsx)$/i;
          if (!reg.test(file.name)) {
            this.info("只支持上传excel文件");
            return;
          }
        }
      }
      if (this.type === "glb") {
        if (this.fileType) {
          if (this.fileType.indexOf(file_format) == -1) {
            this.warning("不支持上传此格式文件");
            return;
          }
        } else {
          let reg = /^.*\.(?:glb)$/i;
          if (!reg.test(file.name)) {
            this.info("只支持上传glb文件");
            return;
          }
        }
      }
      this.beginUpload(file);
    },
    //图片检查
    imageCheck(data) {
      if (data.size / 1024 / 1024 > 32) {
        this.info("图片大小不能超过32MB");
        return;
      }
      let that = this;
      let Url = "";
      if (typeof data == "object") {
        Url = URL.createObjectURL(data);
      } else {
        Url = data;
      }
      console.log("Url", Url);
      let imgObj = new Image();
      imgObj.onload = function() {
        window.URL.revokeObjectURL(Url);
        // console.log("宽", imgObj.width, "高", imgObj.height);
        if (imgObj.width > 30000 || imgObj.height > 30000) {
          that.info("上传图片宽高不能超过30000 x 30000");
        } else {
          that.beginUpload(data);
        }
      };
      imgObj.src = Url;
    },
    //开始上传
    beginUpload(file) {
      if (this.isFile) {
        //只取文件不上传
        this.$emit("onSuccess", file);
        return;
      }
      this.$emit("statusChange", "begin");
      this.showProgress = true;
      console.log("开始上传");
      const options = {
        pathDir: this.pathDir,
      };
      uploadFile(file, this.upload_name, options).then((res) => {
        if (!res) {
          this.$emit("statusChange", "end");
        }
        this.showProgress = false;
        if (res.status == "fail") {
          this.$emit("statusChange", "end");
          this.warning("上传失败");
          return;
        } else if (res.status == "success") {
          this.$emit("statusChange", "end");
          console.log("上传成功", res);
          if (this.type == "image") {
            // if (!this.mustEdit) {
            //   this.$emit("onSuccess", { data: res.response.url });
            // }
            if (this.edit) {
              this.$refs.imageEdit.showModal(res, this.fileInfo);
            } else {
              this.$emit("onSuccess", {
                data: res.response.url,
                type: this.file_type ? this.file_type : this.type,
              });
            }
          } else {
            this.$emit("onSuccess", {
              data: res.response.url,
              type: this.file_type ? this.file_type : this.type,
              duration: this.videoDuration,
            });
            if (this.power["添加"]) {
              if (this.type == "audio" || this.type == "video") {
                this.vodDialog = true;
                this.url = res.response.url;
              }
            }
          }
        }
      });
    },
    toFather(data) {
      if (typeof data == "string") {
        this.$emit("onSuccess", {
          data: data,
          type: this.file_type ? this.file_type : this.type,
        });
        return;
      }
      let item = data;
      item.data = item.url;
      this.$emit("onSuccess", item);
    },
    //转存到媒资库
    save_to_vod() {
      if (!this.title) {
        this.info("标题不能为空");
      } else {
        saveToVod({
          url: this.url,
          title: this.title,
          type: this.type,
        }).then((res) => {
          if (res.code === 0) {
            this.success("后台转存中");
            this.vodDialog = false;
          } else {
            this.warning(res.msg);
          }
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.app-upload-button {
  display: inline-block;
  position: relative;
}

.app-upload-button .el-upload .el-button {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  border-radius: 0.25rem;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  color: #fff;
  background-color: #556ee6;
  border-color: #556ee6;
}

.app-upload-button .disabled .el-upload .el-button {
  pointer-events: none;
  opacity: 0.65;
}

.app-upload-button .uploader-progress {
  width: 100%;
  margin-top: 5px;
  /*position: absolute;*/
}
</style>
<style scoped lang="scss">
::v-deep .t-loading__gradient-conic {
  background: conic-gradient(
    from 90deg at 50% 50%,
    rgba(0, 82, 217, 0) 0deg,
    rgb(255, 255, 255) 360deg
  ) !important;
}
</style>
